import HintIcon from '@images/icons/hint_select_role_icon.svg?react'
import { selectCurrentUserRole, useAppSelector } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import ReactTooltip from 'react-tooltip'

import './expenseManagementTooltip.scss'

const preparedToolTip = () => `
 <div>

 ${tr(
   'FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE1',
   'Expense Management allows you to control how expenses are submitted, reviewed, and approved before payments are processed. You can define a structured approval flow or rely on default permissions.'
 )} <br/> <br/>

  <span> ${tr(
    'FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE2',
    'You can manage your team`s approval settings anytime from User & Department Management under Settings.'
  )}</span> <br/><br/>

   &#8594; ${tr(
     'FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE3',
     'If you want to set up a custom approval matrix:'
   )}
   <ol>
      <li> <b>${tr('FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE4_1', 'Invite Your Team')}</b> -
      ${tr('FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE4_2', 'Add team members and assign roles.')}
      <br/>
      <li> <b>${tr('FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE5_1', 'Set Up Departments')}</b> -
      ${tr('FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE5_2', 'Organize expenses by department.')}
      <br/>
      <li> <b>${tr(
        'FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE6_1',
        'Create a Custom Approval Matrix'
      )}</b> -
      ${tr('FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE6_2', 'Define a structured approval flow.')}
      </ol>
      <br/>
        &#8594; ${tr(
          'FRONTEND.EXPENSE_MANAGEMENT.EXPENSE_MANAGEMENT_TOOLTIP_LINE7',
          'If no approval matrix is set, expenses will follow general approval permissions.'
        )}

`

export const ExpenseManagementTooltip = ({ size = 16 }: { size?: number }) => {
  const customerRole = useAppSelector(selectCurrentUserRole)

  return customerRole === 'STAFF' ? null : (
    <>
      <span className='expense-management-tooltip' data-for='expense-management-tooltip' data-tip={preparedToolTip()}>
        <HintIcon width={size} height={size} />
      </span>
      <ReactTooltip
        id='expense-management-tooltip'
        place='bottom'
        html
        type='dark'
        arrowColor='transparent'
        className='expense-management-tooltip'
        padding='24px'
      />
    </>
  )
}
